import { GetPartnersResponse } from '../types/partner';
import authorizedInstance from './authorizedInstance';

export const PARTNER_BASE_API_ENDPOINT = '/api/v1/students';

export const getPartners = (signal?: AbortSignal) => {
  return authorizedInstance.get<GetPartnersResponse>(`${PARTNER_BASE_API_ENDPOINT}/get-active-partners`, { signal });
};

export const getPartner = (id: string) => {
  return authorizedInstance.get<MindRightPartner>(`${PARTNER_BASE_API_ENDPOINT}/${id}`);
};

export interface MindRightPartner {
  _id: string;
  name: string;
}

export interface GetMindRightPartnersResponse {
  statusCode: number;
  partners: MindRightPartner[];
  message: string;
}

export const searchActiveMindRightPartners = (
  searchQuery: string,
  limit: number = 10,
  signal?: AbortSignal
) => {
  const params = new URLSearchParams();
  if (searchQuery) {
    params.append('search', searchQuery);
  }
  params.append('limit', limit.toString());
  return authorizedInstance.get<GetMindRightPartnersResponse>(
    `${PARTNER_BASE_API_ENDPOINT}/get-active-mindright-partners?${params.toString()}`,
    { signal }
  );
};